import {
  getExchangeBakeryArtworkNFTContract,
  getExchangeOneInchBakeNFTContract,
  getExchangeSeascapeNFTContract,
  getExchangeBakeryArtwork3NFTContract,
  getExchangeBakeryArtwork2NFTContract,
  getExchangeBakerySoccerContract,
  getExchangeTokocryptoNFTContract,
  getExchangeArtworkNFTContract,
  getExchangeSfpNFTContract,
  getExchangeDoggyNFTContract,
  getExchangeLoveNFTContract,
  getExchangeYooshiNFTContract,
  getExchangeNFTContract,
  getExchangeEggNFTContract,
  getExchangeWeaponNFTContract,
  getExchangePetNftContract,
  getExchangeBinanceNftContract,
  getExchangeRacaNFTContract,
  getExchangeBondlyNFTContract,
  getExchangeBscBakeNFTContract,
  getExchangeBarkingNFTContract
} from '../sushi/utils'

import { MARKETTYPEV1 } from '../constants/bakery/nft'

export function userExchangeNFTContract(sushi: any, type?: string) {
  let contract = getExchangeNFTContract(sushi)
  switch (type) {
    case MARKETTYPEV1.DISHV1:
      contract = getExchangeNFTContract(sushi)
      break
    case MARKETTYPEV1.EGGNFTV1:
      contract = getExchangeEggNFTContract(sushi)
      break
    case MARKETTYPEV1.WEAPONNFTV1:
      contract = getExchangeWeaponNFTContract(sushi)
      break
    case MARKETTYPEV1.BINANCENFTV1:
      contract = getExchangeBinanceNftContract(sushi)
      break
    case MARKETTYPEV1.PETNFTV1:
      contract = getExchangePetNftContract(sushi)
      break
    case MARKETTYPEV1.BAKERYARTWORKV1:
      contract = getExchangeBakeryArtworkNFTContract(sushi)
      break
    case MARKETTYPEV1.ONEINCHV1:
      contract = getExchangeOneInchBakeNFTContract(sushi)
      break
    case MARKETTYPEV1.SEASCAPEV1:
      contract = getExchangeSeascapeNFTContract(sushi)
      break
    case MARKETTYPEV1.MEMEV1:
      contract = getExchangeBakeryArtwork3NFTContract(sushi)
      break
    case MARKETTYPEV1.MUSKDOGEV1:
      contract = getExchangeBakeryArtwork2NFTContract(sushi)
      break
    case MARKETTYPEV1.BAKERYSOCCERV1:
      contract = getExchangeBakerySoccerContract(sushi)
      break
    case MARKETTYPEV1.TKONFTV1:
      contract = getExchangeTokocryptoNFTContract(sushi)
      break
    case MARKETTYPEV1.BTCARTWORKV1:
      contract = getExchangeArtworkNFTContract(sushi)
      break
    case MARKETTYPEV1.SFPARTWORKV1:
      contract = getExchangeSfpNFTContract(sushi)
      break
    case MARKETTYPEV1.DOGGYNFTV1:
      contract = getExchangeDoggyNFTContract(sushi)
      break
    case MARKETTYPEV1.LOVEV1:
      contract = getExchangeLoveNFTContract(sushi)
      break
    case MARKETTYPEV1.YOOSHINFTV1:
      contract = getExchangeYooshiNFTContract(sushi)
      break
    case MARKETTYPEV1.RACANFTV1:
      contract = getExchangeRacaNFTContract(sushi)
      break
    case MARKETTYPEV1.BONDLYNFTV1:
      contract = getExchangeBondlyNFTContract(sushi)
      break
    case MARKETTYPEV1.BAKERYBSCARTWORKV1:
      contract = getExchangeBscBakeNFTContract(sushi)
      break
    case MARKETTYPEV1.BARKNFTV1:
      contract = getExchangeBarkingNFTContract(sushi)
      break
  }
  return contract
}
